/**
 * PlayReferenceVisual - Renders an embedded play with display options
 *
 * Uses CanvasRenderer with pre-resolved data to avoid redundant API fetch.
 * Parent containers (SlideVisual, SectionVisual) embed resolved block
 * in properties.__resolved_block before passing to BlockRenderer.
 */

import { ReferenceWrapper, type ReferenceDisplayOptions } from './ReferenceWrapper'
import { CanvasRenderer } from '@/components/canvas-renderer'
import { THUMBNAIL_VIEW_BOX } from '@/constants'
import type { BlockVisualProps } from '../../Types'
import type { PlayReferenceBlock, ResolvedBlock } from '@/types/blocks'

export function PlayReferenceVisual({ block }: BlockVisualProps) {
	if (block.type !== 'play_reference') return null

	const refBlock = block as PlayReferenceBlock
	const resolvedBlock = (refBlock.properties as Record<string, unknown>).__resolved_block as ResolvedBlock | null
	const displayOptions = ((refBlock.properties as Record<string, unknown>).__display_options ?? {}) as ReferenceDisplayOptions

	if (!resolvedBlock) {
		return (
			<div className="play-reference-empty">
				<p style={{ color: 'var(--muted-foreground)' }}>Play not found</p>
			</div>
		)
	}

	return (
		<ReferenceWrapper displayOptions={displayOptions} aspectRatio={16 / 9}>
			<CanvasRenderer
				resolvedBlock={resolvedBlock}
				mode="static"
				viewBox={THUMBNAIL_VIEW_BOX}
			/>
		</ReferenceWrapper>
	)
}
